import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_SCL,
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    // xkey
    const xkey = process.env.REACT_APP_CMS_XKEY;
    if (xkey) {
      config.headers = config.headers ?? {};
      config.headers["x-api-key"] = xkey; 
    }

    return config;
  },
  (error) => Promise.reject(error) //NOSONAR
);

export default api;
